export const copyright: string = 'SSA Retail Group Limited. All rights reserved.';
export const vatNumber: string = '495 8556 24';